<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_mode')}}:
								| {{ $i18n.t('couples.couples_view_' + settings.viewType) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
								| {{ settings.difficult.amountOfRows + ' x ' + settings.difficult.amountOfColumns }}
						br
						template(v-if='settings.selectedTopics.length')
								| {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}:
								template(v-for='topic in settings.selectedTopics')
										span
												| {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + topic) }};
										br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
